// frontend/src/components/Layout/ProviderLayout.tsx
import React from 'react';
import BaseLayout from './BaseLayout';
import { providerLayoutConfig } from './configs/layoutConfigs';

interface ProviderLayoutProps {
  children: React.ReactNode;
}

const ProviderLayout: React.FC<ProviderLayoutProps> = ({ children }) => {
  return (
    <BaseLayout config={providerLayoutConfig}>
      {children}
    </BaseLayout>
  );
};

export default ProviderLayout;